<template>
    <business-intelligence-page :product-id="contract.id" :product-type="productType" hide-breadcrumbs />
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import BusinessIntelligencePage from '@/pages/BusinessIntelligencePage.vue'

    @Component({
        components: {
            BusinessIntelligencePage,
        },
    })
    export class ProductBIForm extends Vue {
        @Prop({required: true}) contract

        get productType() {
            switch (this.contract.serviceType) {
                case 'ownExcursion':
                    return 'EXCURSION'
                case 'ownCharter':
                    return 'FLIGHT'
                case 'ownTransfer':
                    return 'TRANSFER'
            }
        }
    }

    export default ProductBIForm
</script>
